import React, { useState, useEffect, useMemo } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { Link } from "react-router-dom";
import withRouter from "../../Common/withRouter";
import { createSelector } from "reselect";

// users
// import user1 from "../../../assets/images/users/avatar-1.jpg";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setLogout } from "slices/auth/login/reducer";

import { createAvatar } from "@dicebear/core";
import { shapes } from "@dicebear/collection";
import { AppRoutes } from "../../../constants";

const ProfileMenu = (props: any) => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const dispatch = useDispatch<any>();

  const [username, setUsername] = useState("Admin");

  const selectProfileProperties = createSelector(
    (state: any) => state.Profile,
    (profile) => ({
      user: profile.user,
    })
  );
  const avatar = useMemo(() => {
    return createAvatar(shapes, {
      size: 128,
      seed: username,
      backgroundColor: ["2a3042"],
      shape2Color: ["2ca56e"],
      shape3Color: ["39c486"],
      // ... other options
    }).toDataUri();
  }, [username]);

  const { user } = useSelector(selectProfileProperties);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser") || "");
        setUsername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setUsername(user?.username);
      }
    }
  }, [user]);

  const logout = () => {
    dispatch(setLogout());
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={avatar}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">
            {username || "admin"}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href={process.env.PUBLIC_URL + "/profile"}>
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>

          <DropdownItem onClick={props.toggleCanvas}>
            <i className="bx bx-paint font-size-16 align-middle me-1" />
            {props.t("App Theme")}
          </DropdownItem>
          <DropdownItem tag="a" href={AppRoutes.SETTINGS}>
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem>
          <div className="dropdown-divider" />
          <Link to="/#" onClick={() => logout()} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(ProfileMenu));
